import type { Configuration, RedirectRequest } from "@azure/msal-browser";
import { envConfig } from "utils/envConfig";

export const msalConfig: Configuration = {
  auth: {
    clientId: envConfig.MsalClientId || "ERROR_UNKNOWN_CLIENT_ID",
    authority: "https://login.microsoftonline.com/" + envConfig.MsalTenantId,
    redirectUri: window.location.origin + "/",
    postLogoutRedirectUri: window.location.origin + "/",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  // system: {
  //     loggerOptions: {
  //         loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
  //             if (containsPii) {
  //                 return;
  //             }
  //             switch (level) {
  //                 case LogLevel.Error:
  //                     console.error(message);
  //                     return;
  //                 case LogLevel.Info:
  //                     console.info(message);
  //                     return;
  //                 case LogLevel.Verbose:
  //                     console.debug(message);
  //                     return;
  //                 case LogLevel.Warning:
  //                     console.warn(message);
  //                     return;
  //             }
  //         },
  //         piiLoggingEnabled: false,
  //     },
  //     windowHashTimeout: 60000,
  //     iframeHashTimeout: 6000,
  //     loadFrameTimeout: 0,
  //     asyncPopups: false,
  // },
};

export const loginRequest: RedirectRequest = {
  scopes: ["openid", "profile", "email", envConfig.MsalApiScope || ""],
  // Include standard OIDC scope "openid" to ensure appropriate ID token claims
};
